import { TrendingItemsComponentProps, TrendingItemsEditorProps } from './TrendingItems.types';

/**
 * 기존 데이터 형식을 새로운 형식으로 변환
 * 
 * @param originalProps 기존 컴포넌트의 props
 * @returns 변환된 새로운 컴포넌트용 props
 */
export function adaptTrendingItemsProps(originalProps: any): TrendingItemsComponentProps {
  // 기본값 설정 (빈 객체로 초기화)
  const originalComponentProps = originalProps?.componentProps || {};
  
  // 스타일 통합 (깊은 복사)
  const style = {
    ...(originalProps?.style || {}),
  };
  
  // 뷰모드 추출
  const viewMode = originalProps?.viewMode || 'pc';
  const isMobile = viewMode === 'mobile' || viewMode === 'tablet';
  
  // 디바이스별 스타일 적용
  if (originalComponentProps?.styles) {
    const deviceStyles = isMobile
      ? originalComponentProps.styles.mobile
      : originalComponentProps.styles.pc;
      
    if (deviceStyles) {
      Object.assign(style, deviceStyles);
    }
  }
  
  // className 설정
  const className = originalProps?.className || 
                   originalComponentProps?.className || 
                   'trending-items-component';

  // 기본 아이템 목록
  const defaultItems = [
    {
      id: 1,
      image: "https://via.placeholder.com/400x400",
      title: "민감성 피부 스킨&케어",
      url: "#"
    },
    {
      id: 2,
      image: "https://via.placeholder.com/400x400",
      title: "수분 마스크팩 듀오 할인",
      url: "#"
    },
    {
      id: 3,
      image: "https://via.placeholder.com/400x400",
      title: "저자극 버블 클렌저 기획전",
      url: "#"
    }
  ];

  // 변환된 props 반환
  const adaptedProps: TrendingItemsComponentProps = {
    id: originalProps?.id || '',
    style,
    className,
    isPreview: originalProps?.isPreview || false,
    viewMode: originalProps?.viewMode || 'pc',
    componentProps: {
      className,
      title: originalComponentProps?.headingText !== undefined ? originalComponentProps.headingText :
             originalComponentProps?.mainTitle !== undefined ? originalComponentProps.mainTitle : 
             originalComponentProps?.title !== undefined ? originalComponentProps.title :
             originalProps?.title !== undefined ? originalProps.title :
             originalProps?.data?.title !== undefined ? originalProps.data.title : "Trending now",
      subtitle: originalComponentProps?.subtitle !== undefined ? originalComponentProps.subtitle : "에디터가 선정한",
      is_logged: originalComponentProps?.is_logged !== undefined ? originalComponentProps.is_logged : true,
      is_not_logged: originalComponentProps?.is_not_logged !== undefined ? originalComponentProps.is_not_logged : true,
      imageRadius: originalComponentProps?.imageRadius || "4px",
      // MORE 버튼 관련 속성
      showMoreButton: originalComponentProps?.showMoreButton !== undefined ? originalComponentProps.showMoreButton : true,
      moreButtonText: originalComponentProps?.moreButtonText || "MORE",
      moreButtonUrl: originalComponentProps?.moreButtonUrl || "#",
      // MORE 버튼 색상 속성
      moreButtonTextColor: originalComponentProps?.moreButtonTextColor || "#8a7a6d",
      moreButtonBorderColor: originalComponentProps?.moreButtonBorderColor || "#8a7a6d",
      moreButtonBgColor: originalComponentProps?.moreButtonBgColor || "transparent",
      moreButtonHoverTextColor: originalComponentProps?.moreButtonHoverTextColor || "#ffffff",
      moreButtonHoverBgColor: originalComponentProps?.moreButtonHoverBgColor || "#8a7a6d",
      items: originalComponentProps?.items || defaultItems,
      styles: originalComponentProps?.styles || {}
    }
  };
  


  // 외부 스킨 지원
  if (originalProps?.externalSkin) {
    adaptedProps.externalSkin = originalProps.externalSkin;
  }
  
  // 테마 지원
  if (originalProps?.theme) {
    adaptedProps.theme = originalProps.theme;
  }
  
  // 에디터 관련 props
  if (originalProps?.isEditor) {
    adaptedProps.isEditor = originalProps.isEditor;
  }
  if (originalProps?.isSelected) {
    adaptedProps.isSelected = originalProps.isSelected;
  }
  if (originalProps?.onSelect) {
    adaptedProps.onSelect = originalProps.onSelect;
  }
  if (originalProps?.onEdit) {
    adaptedProps.onEdit = originalProps.onEdit;
  }
  if (originalProps?.onDelete) {
    adaptedProps.onDelete = originalProps.onDelete;
  }
  if (originalProps?.updateComponent) {
    adaptedProps.updateComponent = originalProps.updateComponent;
  }
  if (originalProps?.dragHandleProps) {
    adaptedProps.dragHandleProps = originalProps.dragHandleProps;
  }
  
  // 원본 props의 모든 속성 중 이미 처리한 속성 제외하고 나머지 복사
  const excludeKeys = ['style', 'className', 'isPreview', 'viewMode', 'componentProps', 'id', 'externalSkin', 'theme', 'isEditor', 'isSelected', 'onSelect', 'onEdit', 'onDelete', 'updateComponent', 'dragHandleProps'];
  
  Object.keys(originalProps).forEach(key => {
    if (!excludeKeys.includes(key)) {
      adaptedProps[key] = originalProps[key];
    }
  });

  return adaptedProps;
}

/**
 * 에디터용 데이터 형식 변환
 * 
 * @param originalProps 기존 컴포넌트의 props
 * @returns 변환된 에디터 컴포넌트용 props
 */
export function adaptTrendingItemsEditorProps(originalProps: any): TrendingItemsEditorProps {

  // 기본 props 변환 사용
  const adaptedProps = adaptTrendingItemsProps(originalProps) as TrendingItemsComponentProps;
  
  // 에디터 관련 추가 props
  return {
    ...adaptedProps,
    isSelected: originalProps.isSelected || false,
    updateComponent: originalProps.updateComponent || (() => {})
  };
} 